const QuickStartBase = '/quick-start';
export const QuickStart = {
  Base: QuickStartBase,
  Settings: `${QuickStartBase}/settings`,
  New: `${QuickStartBase}/new`,
  LinkedUsers: `${QuickStartBase}/linked-users`, // Has route parameter (/:customer_app_id)
  Guide: `${QuickStartBase}/guide`,
  Customizations: `${QuickStartBase}/ui-customizations`,
};

export const Application = {
  Base: '/applications',
  Settings: '/applications/settings',
};

const TeamsBase = '/teams';
export const Teams = {
  Base: TeamsBase,
  InviteMember: `${TeamsBase}/invite-member`,
  InviteMemberV2: `${TeamsBase}/invite-member-v2`,
  MembersV2: `${TeamsBase}/members-v2`,
  AddTeam: `${TeamsBase}/add-team`,
  Settings: `${TeamsBase}/settings`,
};

const ReportsBase = '/reports';
export const Reports = {
  Base: ReportsBase,
  Payments: `${ReportsBase}/payments`,
  Payouts: `${ReportsBase}/payouts`,
  PaymentMethods: `${ReportsBase}/payment-methods`,
  Statement: `${ReportsBase}/statement`,
  Bills: `${ReportsBase}/bills`,
};

const AdyenBase = '/settings/integrations/adyen';
export const Adyen = {
  Base: AdyenBase,
  Transactions: `${AdyenBase}/transactions`,
  Payouts: `${AdyenBase}/payouts`,
  Reports: `${AdyenBase}/reports`,
  Disputes: `${AdyenBase}/disputes`,
};

const IntegrationsBase = '/settings/integrations';
export const Integrations = {
  Base: IntegrationsBase,
  Xero: `${IntegrationsBase}/xero`,
  Adyen: Adyen,
};

const LoginBase = '/login';
export const Login = {
  Base: LoginBase,
  XeroLogin: `${LoginBase}/xero`,
};

const Routes = {
  Login: Login,
  Logout: '/logout',
  Overview: '/overview',
  Register: '/register',
  QuickStart: QuickStart,
  Reports: Reports,
  Application: Application,
  Customizations: '/customizations',
  Verified: '/verified',
  Callback: '/callback',
  CallbackV2: '/callback_v2',
  Echo: '/echo',
  Error: '/error', // Has route parameter (/:message)
  Home: '/',
  Invite: '/invite/:inviteCode',
  Docs: 'https://docs.finverse.com/',
  Teams: Teams,
  Integrations: Integrations,
};

export default Routes;
